import React from 'react'
import classnames from 'classnames'
import { fnum } from '../../utils/utils'

class AvansPostItem extends React.Component {

  state = {
    errors: {}
  }

  toggleAvans = (e) => {
    const post_avans = this.props.data.post_avans === 1 ? 0 : 1;
    this.props.editPost({
      post_id: this.props.data.post_id,
      post_avans
    }, (errors) => {
      if (errors) {
        this.setState({errors});
      }
    });
  }

  render() {

    const { data, num } = this.props;
    const { errors } = this.state;
    const trClass = classnames({
      'hidden-print': !data.post_avans,
      'has-error': errors.form,
      'text-muted': !data.post_avans
    });
    return (
      <tr
        className={trClass}
      >
        <td className="hidden-print">
          <input
            type="checkbox"
            onChange={this.toggleAvans}
            checked={data.post_avans}
          />
          {errors.form && <div className="help-block">{errors.form}</div>}
        </td>
        <td>{num}</td>
        <td>{data.post_desc + data.cost_desc}</td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td className="text-right"></td>
        <td>{data.post_note}</td>
      </tr>
    )
  }
}

export default AvansPostItem;



// WEBPACK FOOTER //
// ./src/components/avans/AvansPostItem.js